import { render, staticRenderFns } from "./MyPlans.vue?vue&type=template&id=639fc7c6&scoped=true"
import script from "./MyPlans.vue?vue&type=script&lang=ts"
export * from "./MyPlans.vue?vue&type=script&lang=ts"
import style0 from "./MyPlans.vue?vue&type=style&index=0&id=639fc7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fc7c6",
  null
  
)

export default component.exports